import { configureStore } from "@reduxjs/toolkit";
import userSessionsReducer from "./slice/get-user-sessions";
import userChatsReducer from "./slice/get-user-chats";
import userChatReducer from "./slice/post-user-chat";
import deleteUserReducer from "./slice/delete-user-session";
import renameUserReducer from "./slice/rename-user-session";
import userFeedbackReducer from "./slice/user-feedback";
import newChatReducer from "./slice/new-chat-session";
import snackbarReducer from "./slice/snackbar";
import streamingReducer from "./slice/stream-thunk";
import newChatStreaming from "./slice/new-stream-thunk";
import doctorsbrandReducer from "./slice/doctor-focus-brands";
import userNameReducer from "./slice/get-user-name";
import generateTokenReducer from "./slice/generate-token";
import exportToExcelReducer from "./slice/export-to-excel";
import repEmailsReducer from "./slice/get-rep-emails";
import speechConfigReducer from "./slice/azure-speech-config";
import rbdPerformanceMetricsReducer from "./slice/rbd-performance-metrics";
import kpiWidgetMetricsReducer from "./slice/kpi-widget-metrics";
import leadershipMetricsReducer from "./slice/leadership-metrics";
import callLogReducer from "./slice/callLogSlice";
import widgetOrderReducer from "./slice/widget-order";
import authReducer from "./slice/auth-slice";
import knowledgeBotStreamReducer from "./slice/knowledge-bot-stream";
export const store = configureStore({
  reducer: {
    auth: authReducer,
    userSessions: userSessionsReducer,
    userChats: userChatsReducer,
    userChat: userChatReducer,
    deleteUser: deleteUserReducer,
    renameUser: renameUserReducer,
    userFeedback: userFeedbackReducer,
    newChat: newChatReducer,
    snackbar: snackbarReducer,
    stream: streamingReducer,
    newChatStream: newChatStreaming,
    doctorbrand: doctorsbrandReducer,
    userName: userNameReducer,
    accessToken: generateTokenReducer,
    exportExcel: exportToExcelReducer,
    repEmails: repEmailsReducer,
    speechConfig: speechConfigReducer,
    rbdPerformanceMetrics: rbdPerformanceMetricsReducer,
    kpiWidgetMetrics: kpiWidgetMetricsReducer,
    leadershipMetrics: leadershipMetricsReducer,
    callLog: callLogReducer,
    widgetOrder: widgetOrderReducer,
    knowledgeBotStream: knowledgeBotStreamReducer,
  },
});
